
let url = 'http://api.dev.gdteacher.com';
let studySpaceUrl = '';
let managerUrl = '';
if (process.env.NODE_ENV === 'development') {
  // url = 'http://api.tt.ttcn.cn';
  url = 'https://api.dev.gdteacher.com';

  // url = 'http://172.16.146.184:81'
} else if (process.env.NODE_ENV === 'test') {
  url = 'https://api.test.gdteacher.com';
} else if (process.env.NODE_ENV === 'production') {
  url = 'https://api.ttcn.cn';
}


export const apis = {
  imageUpload: 'https://file.gzteacher.com/apiUpload/upload.do',
  api: {
    studySpace:studySpaceUrl,//个人空间地址
    managerUrl:managerUrl,
    domainUrl:'',
    login: {
      getCodeImage: url + '/captcha/imageUrl', //获取图形验证码
      teacherLogin: url + '/oauthService/teacher/login', //项目登录接口
      getAPPInfo: url + '/baseData/app-info/search', //获取应用信息
      getCurrentProjectId: url + '/yjypService/project/getCurrentProject', //获取当前项目空间的projectId
      getMyTrainProjectList: url + '/yjypService/project/getMyTrainProjectList/', //获取当前用户参与的项目
      modifyPassword: url + '/baseData/user/user/v2/modifyPassword',
      changePwd: url + '/baseData/user/user/changePwdMd5',
    },
    system:{
      checkToken: url + '/oauthService/checkToken/'
    },
    showSpecial: {
      getMicroAndTermList: url + '/tsgc2Service/micro-ability/getMicroAndTermList/', //获取课程列表
      getPageSetting: url + '/yjypService/show-page/', //查询展示页设置
      getPreviewResearchUrl: url + '/studyService/plan/research-project/getPreviewResearchUrl?formMap.RESEARCH_ID=', //查询展示页设置
    },
    resourceCenter:{
      resourceList: url + '/trainService/groupResult/research-attachment/findAllFilterAttInfoIdNotNull',//资源列表
      //resourceList: url + '/trainService/groupResult/research-attachment/page-search',//资源列表
      //labelList:url+'/baseData/basecode/findSubjectAndSection'//树形学科学段
      labelList:url+'/baseData/basecode/findSubjectAndSection?format=1',//平铺学科学段
      delComments: url + '/trainService/groupResult/comments/',
      commentsSupport: url + '/trainService/groupResult/comments/support',
      getCommentDetail: url + '/trainService/groupResult/comments/getCommentDetail',
      getResearch: url + '/trainService/groupResult/research-attachment',
      getAttachmentSortList: url + '/trainService/groupResult/attachment-sort/getAttachmentSortList',
      findSubjectAndSection: url + '/baseData/basecode/findSubjectAndSection',
      commentsfindAll: url + '/trainService/groupResult/comments/findAll',
      commentsSave: url + '/trainService/groupResult/comments/save',
      getResearchUserInfo: url + '/trainService/groupResult/research-article/getResearchUserInfo',
      getResearchTopic: url + '/trainService/groupResult/research-topic',
      getResearchDetailDetail: url + '/trainService/groupResult/research-article/getResearchDetailDetail',
      researchScore: url + '/trainService/research/score',
      attachmenttop: url + '/trainService/groupResult/research-attachment/top',
      attachmentWonderful: url + '/trainService/groupResult/research-attachment/wonderful'
    },
    square:{
      groupList:url+'/trainService/group/group/hotGroup'//热门工作坊
     // groupList:'http://172.16.166.19:9999/group/group/hotGroup'//热门工作坊
    },
    home:{
      getCategoryId: url + '/yjypService/category/search?pageSize=20', //获取栏目Id
      getCategoryList: url + '/yjypService/article/getArticleByCategoryIds/', //获取各栏目数据
      getArticleDetails: url + '/yjypService/article/' //获取文章详情
    },
    microStatistics: {
      getProjectUserTsgcStatSnapshoot1: url + '/analysisService/getProjectUserTsgcStatSnapshoot1?projectId=', //维度微能力点认证通过情况
      getProjectUserTsgcStatSnapshoot2: url + '/analysisService/getProjectUserTsgcStatSnapshoot2?projectId=', //微能力材料提交与认证情况
      getProjectUserTsgcStatSnapshoot3: url + '/analysisService/getProjectUserTsgcStatSnapshoot3?projectId=', //已认证微能力点
      getProjectUserTsgcStatSnapshoot4: url + '/analysisService/getProjectUserTsgcStatSnapshoot4?projectId=', //已认证微能力点
      getProjectSchoolTsgcStatSnapshoot1: url + '/analysisService/getProjectSchoolTsgcStatSnapshoot1?projectId=', //环境与微能力材料认证情况
      getProjectSchoolTsgcStatSnapshoot2: url + '/analysisService/getProjectSchoolTsgcStatSnapshoot2?projectId=', //维度与微能力材料认证情况
      getProjectSchoolTsgcStatSnapshoot3: url + '/analysisService/getProjectSchoolTsgcStatSnapshoot3/', //教师学情
      getProjectSchoolTsgcStatSnapshoot3Export: url + '/analysisService/getProjectSchoolTsgcStatSnapshoot3Export/' //教师学情导出
    },
    statistics: {
      schoolCondition: url + '/analysisService/tsgc2/project/stat?projectId=',
      districtData: url + '/analysisService/tsgc2/project/district/stat?projectId=',
      yxResource: url + '/analysisService/tsgc2/yxResource/stat?projectId=',
      findCodeByTypeCode: url + '/baseData/basecode/findCodeByTypeCode?typeCode=school_type',
      page: url + '/baseData/organ/school/page',
      schoollamp: url + '/tsgc2Service/tsgc/school-lamp/page-search',
      // schoolCondition: url + '/tsgc2Service/projectSituation/personalSpaceSchoolCount',
      // schoolCondition: url + '/analysisService/tsgc2/project/stat?projectId=', //校长学校学情
      subjectTeamCondition: url + '/analysisService/tsgc2/project/stat/subjectTeam?projectId=', //学科组长学情
      // teacherCondition: url + '/yjypService/projectUser/search',
      teacherCondition: url + '/analysisService/tsgc2/school/stat?projectId=', //教师学情
      // leaderCondition: url + '/tsgc2Service/subject-team-user/findBySituationByTeamLeaderUserId',
      getUpdateTime: url + '/analysisService/manual/getTaskTime/task_tsgc_01',
      getSubmitMaterialsCount: url +
        '/tsgc2Service/submit-materials/getSubmitMaterialsCount?projectId=', //应交材料情况
      exportStatistics: url + '/analysisService/tsgc2/school/stat/export?projectId=', //导出教师学情
      getUserTeamMessage: url + '/tsgc2Service/subject-team-user/getUserTeamMessage?projectId=', //获取教师学科组
      schoolpage: url + '/tsgc2Service/tsgc/school-notice/page-search',

      
      
    }
  }
};




// WEBPACK FOOTER //
// ./src/core/apis.js